module.exports = __webpack_public_path__ + "assets/img/exist_category_misplaced.6c25e9c2.png";